import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { FileClock } from "lucide-react";

export default function DocScadConfigCard() {
  const [c, setC] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/docscad").then((r) => setC(r.data)).catch(() => setC(null)); }, []);
  if (!c) return null;
  const save = async () => {
    const g = parseInt(c.preavviso_giorni, 10), m = parseInt(c.visura_mesi, 10);
    if (!(g >= 1) || !(m >= 1)) { toast.error("Inserisci numeri maggiori di zero"); return; }
    setSaving(true);
    try { const r = await api.put("/settings/docscad", { preavviso_giorni: g, visura_mesi: m }); setC(r.data); toast.success("Impostazioni salvate"); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore nel salvataggio"); } finally { setSaving(false); }
  };
  const row = (k, label, suf, testid) => (
    <div className="flex items-center justify-between gap-3">
      <label className="text-sm flex-1" htmlFor={testid}>{label}</label>
      <div className="flex items-center gap-1.5">
        <input id={testid} data-testid={testid} type="number" min="1" value={c[k]} onChange={(e) => setC({ ...c, [k]: e.target.value })}
          className="w-20 px-2.5 py-2 rounded-lg border border-[var(--border)] text-sm text-right" />
        <span className="text-xs text-[var(--muted)] w-10">{suf}</span>
      </div>
    </div>
  );
  return (
    <div className="card-immo p-5 mt-6" data-testid="docscad-config-card">
      <div className="flex items-center gap-2 mb-1"><span className="w-8 h-8 rounded-xl bg-[#FC82ED]/15 text-[#FC82ED] flex items-center justify-center"><FileClock size={16} /></span><h2 className="font-display font-bold text-base">Documenti in scadenza</h2></div>
      <p className="text-xs text-[var(--muted)] mb-4">Avvisi e task all'agente per documento d'identità, APE e visura (default: 30 giorni / 6 mesi).</p>
      <div className="space-y-3">
        {row("preavviso_giorni", "Preavviso prima della scadenza", "giorni", "docscad-preavviso")}
        {row("visura_mesi", "Visura da rifare dopo", "mesi", "docscad-visura")}
      </div>
      <button data-testid="docscad-salva" onClick={save} disabled={saving} className="w-full mt-4 py-2.5 rounded-xl bg-[#111111] text-white font-semibold text-sm disabled:opacity-50">{saving ? "Salvo…" : "Salva"}</button>
    </div>
  );
}
